import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || '/api'

export const chatApi = {
  getSessions: async () => {
    const response = await axios.get(`${API_URL}/chat/sessions`)
    return response.data
  },

  getSession: async (sessionId) => {
    const response = await axios.get(`${API_URL}/chat/sessions/${sessionId}`)
    return response.data
  },

  createSession: async (sessionData) => {
    const response = await axios.post(`${API_URL}/chat/sessions`, sessionData)
    return response.data
  },

  updateSession: async (sessionId, sessionData) => {
    const response = await axios.patch(`${API_URL}/chat/sessions/${sessionId}`, sessionData)
    return response.data
  },

  deleteSession: async (sessionId) => {
    const response = await axios.delete(`${API_URL}/chat/sessions/${sessionId}`)
    return response.data
  },

  pinSession: async (sessionId) => {
    const response = await axios.post(`${API_URL}/chat/sessions/${sessionId}/pin`)
    return response.data
  },

  unpinSession: async (sessionId) => {
    const response = await axios.post(`${API_URL}/chat/sessions/${sessionId}/unpin`)
    return response.data
  },

  getMessages: async (sessionId) => {
    const response = await axios.get(`${API_URL}/chat/sessions/${sessionId}/messages`)
    return response.data
  },

  sendMessage: async (sessionId, content) => {
    const response = await axios.post(`${API_URL}/chat/sessions/${sessionId}/messages`, {
      content
    })
    return response.data
  },

  deleteMessage: async (sessionId, messageId) => {
    const response = await axios.delete(`${API_URL}/chat/sessions/${sessionId}/messages/${messageId}`)
    return response.data
  },

  getContacts: async (teamId) => {
    const response = await axios.get(`${API_URL}/chat/contacts`, {
      params: { teamId }
    })
    return response.data
  },

  getRecentContacts: async () => {
    const response = await axios.get(`${API_URL}/chat/contacts/recent`)
    return response.data
  },

  searchUserByAccount: async (account) => {
    const response = await axios.get(`${API_URL}/chat/contacts/search`, {
      params: { account }
    })
    return response.data
  },

  getMeetingRooms: async () => {
    const response = await axios.get(`${API_URL}/chat/meetings/rooms`)
    return response.data
  },

  createMeetingRoom: async (roomData) => {
    const response = await axios.post(`${API_URL}/chat/meetings/rooms`, roomData)
    return response.data
  },

  updateMeetingRoom: async (roomId, roomData) => {
    const response = await axios.patch(`${API_URL}/chat/meetings/rooms/${roomId}`, roomData)
    return response.data
  },

  deleteMeetingRoom: async (roomId) => {
    const response = await axios.delete(`${API_URL}/chat/meetings/rooms/${roomId}`)
    return response.data
  },

  getScheduledMeetings: async () => {
    const response = await axios.get(`${API_URL}/chat/meetings/scheduled`)
    return response.data
  },

  scheduleMeeting: async (meetingData) => {
    const response = await axios.post(`${API_URL}/chat/meetings/schedule`, meetingData)
    return response.data
  },

  joinMeeting: async (roomId) => {
    const response = await axios.post(`${API_URL}/chat/meetings/rooms/${roomId}/join`)
    return response.data
  },

  leaveMeeting: async (roomId) => {
    const response = await axios.post(`${API_URL}/chat/meetings/rooms/${roomId}/leave`)
    return response.data
  },

  getMeetingTranscript: async (roomId) => {
    const response = await axios.get(`${API_URL}/chat/meetings/rooms/${roomId}/transcript`)
    return response.data
  },

  getMyMeetings: async () => {
    const response = await axios.get(`${API_URL}/chat/meetings/my`)
    return response.data
  },

  getMyTasks: async () => {
    const response = await axios.get(`${API_URL}/chat/tasks/my`)
    return response.data
  },

  createTaskSession: async (taskId) => {
    const response = await axios.post(`${API_URL}/chat/sessions/from-task`, {
      taskId
    })
    return response.data
  },

  getUnreadCount: async () => {
    const response = await axios.get(`${API_URL}/chat/unread`)
    return response.data
  },

  markAsRead: async (sessionId) => {
    const response = await axios.post(`${API_URL}/chat/sessions/${sessionId}/read`)
    return response.data
  }
}
